import { Tab, TabId, Tabs } from "@blueprintjs/core"
import { useRef, useState } from "react"
import { WINDOW_WIDTH } from "src/libs/interfaces/layouts"
import useScreenSize from "src/modules/pe-basic-module/hooks/useScreenSize"
import { defaultSection } from "src/modules/pe-landing-module/data/defaults/defaultSection"
import { TabsContent } from "src/modules/pe-landing-module/data/interfaces"
import "../../../assets/css/tabs.scss"
import { IPrimitiveProps } from "../section/Primitive"
import { SectionDataFeed } from "../section/section-design-type"

/* Protopia Ecosystem component */ 
const TabsPrimitive = (props: IPrimitiveProps): JSX.Element => {
    const ref = useRef<any>(null) 
    const { width } = useScreenSize()
    const primitive: TabsContent = ( props.primitive || {} ) as TabsContent  
    const [selectedTabId, setSelectedTabId] = useState<TabId>( !!primitive.items?.length ? primitive.items[0].id : "id" ) 

    return <div className={`flex-centered flex-wrap w-100  landing-tabs-${primitive.tabs_design_type} ${primitive.className}`}>
        <Tabs
            onChange={setSelectedTabId} 
            selectedTabId={selectedTabId} 
            vertical={ width > WINDOW_WIDTH.MOBILE ? primitive.vertical : true } 
            animate 
            fill 
            size="large"
        >
            {
                primitive.items?.map((item, i) => {
                    return <Tab
                        ref={ref}
                        key={item.id}
                        id={item.id}
                        title={item.title}
                        panel={
                            <div className="pt-4  mx-3">
                                <SectionDataFeed
                                    data={ [
                                        ...(item.panel || [])
                                    ] }
                                    section={{
                                        ...defaultSection() , 
                                        data: [ ...(item.panel || []) ]
                                    }}
                                />
                            </div>
                        }
                    />
                })
            } 
        </Tabs>
    </div>  
}
export default TabsPrimitive